import { Component, Input } from '@angular/core';
import { AngularModule } from '../../../../../modules/angular.module';

@Component({
	selector: 'app-carousel-description',
	standalone: true,
	imports: [AngularModule],
	templateUrl: './carousel-description.component.html',
	styleUrl: './carousel-description.component.scss',
})
export class CarouselDescriptionComponent {
	@Input('html') public html: string | null | undefined;
}
